import { Id } from "./id";

type Element = {
  type: "column" | "section";
  label: {
    fr: string;
    en: string;
  };
  key: string;
  elements: Element[];
};

type ConfigurationProfile = {
  roles: Id[];
  name: string;
  elements: Element[];
};

type ProjectListingConfiguration = ConfigurationProfile[];

const projectListingConfiguration: ProjectListingConfiguration = [];

export type { ProjectListingConfiguration };

export { projectListingConfiguration };
